export default __webpack_public_path__ + "static/10_32-596c220fc83dc2ae3bec9d63e6557d4a.png";